import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {
  ContactCardLocationsEnum,
  ContactCardPanelState,
} from '../../../../store/panels/contacts/contactCard/contactCardPanelState';

/*
 * Props.
 */

interface ContactCardFooterNewEventProps {
  hasNoCalendars: boolean;
  panel: ContactCardPanelState;
  onCreateNewEvent: Handler;
}

/*
 * Component.
 */

export const ContactCardFooterNewEvent: FC<ContactCardFooterNewEventProps> = (props) => {
  const theme = useUserTheme();
  const {
    hasNoCalendars,
    panel: {location},
    onCreateNewEvent,
  } = props;

  // If we are currently creating an event, do now show the button.
  if (hasNoCalendars || location === ContactCardLocationsEnum.CALENDAR_NEW_EVENT) {
    return null;
  }
  return (
    <IconButton
      iconName="newEvent"
      color={theme.greys.shade70}
      hoverColor={theme.greys.shade80}
      placement="top"
      label={<Trans id="contact-card-footer-action-new-event">New event</Trans>}
      onClick={onCreateNewEvent}
    />
  );
};
